import {Component, Input, OnInit} from '@angular/core';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { GlobalQuestionService } from 'src/app/modules/shared/services/global-question.service';
import {environment} from '../../../../../environments/environment';
import { Alert } from 'src/app/modules/shared/utilities';
import { RouterLinks } from 'src/app/modules/shared/constants';

declare var $: any;
declare function notify(): any;

@Component({
    selector: 'app-referrals',
    templateUrl: './referrals.component.html',
    styleUrls: ['./referrals.component.scss'],
    standalone: false
})
export class ReferralsComponent implements OnInit {

  
  isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  shareUrl = 'https://everything.insure/invite/8bd376';
  popup_w  = 650;
  popup_h = 400;
  popup_left = (window.screen.width / 2) - ((this.popup_w / 2) + 10);
  popup_top = (window.screen.height / 2) - ((this.popup_h / 2) + 50);
  path = environment.cssURL;
  notify: any;
  campaign: any;
  selectedtCampaign: any;
 links: any;
 user: any;
 showDetails = false;
 RouterLinks = RouterLinks;   
 referrals: any;
 summary: any;
 emailControl: any[] = [{ "placeholder": "Your friends email address" }];
 emailAddresses: any[] = [];
 selectedReferral: any;
  constructor(
   public globalQuestionService: GlobalQuestionService,
   private userStore: UserStore
  ) {
   this.globalQuestionService.spinner(true);
    this.notify = notify();
    this.user = this.userStore.getValue();
    
  }

   ngOnInit(): void {
      this.shareUrl = `${this.path}?referrer_code=${this.user?.person_code}&campaign_id=`;
      const parameters = new Map<string, string>();
      parameters.set('person_id', this.user?.person_id?.toString());
      this.globalQuestionService.runCommandNew(`getReferrals`, parameters, true)
         .subscribe(main => {
            this.campaign = main[0];
            this.referrals = main[1];
            this.summary = main[2];
            console.log( this.campaign );
            setTimeout(() => {
               this.initBannerSlider();
               $('.link-modal').attr('data-toggle','modal');
               this.globalQuestionService.spinner(false);
            }, 2000);
            
            
         });
      //this.initializeSocial();
   }
   ngAfterViewInit(): void {
      setTimeout(() => {
         $('#app-bar-desktop').find('#more').addClass('is-active');
         $('#overview-sub-3').removeClass('d-none');
         $('#overview-sub-3 .navbar-sub__nav').html('Referrals');
       }, 2000);
   }
   initBannerSlider(): void{
      var $slider = $("#banner-slider");
        var $paginator = $('#banner-slider-paginator');

        $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            if (!slick.$nextArrow || slick.$nextArrow.hasClass('slick-hidden')) {
                $paginator.text('');
                return;
            }
            var i = (currentSlide ? currentSlide : 0) + 1;
            $paginator.text(i + ' of ' + slick.slideCount);
        });

        $slider.slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            // swipe: false,
            draggable: false,
            swipeToSlide: true,         
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
            rows: 0,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        fade: true,
                        speed: 400,
                        cssEase: "ease-in",
                    },
                }
            ],
        });

        var referralsSidesheet = (function () {

         function init(args){
 
             // close listeners...
 
             // on back button
             $(document).on('click', '.sidesheet__header-back', function () {
                 closeSidesheet();
             });
 
             // on outside click
             $(document).on('click.outsidesidesheet', function (e) {
                 var $target = $(e.target);
                 if (!$target.closest("#sidesheet").length && !$target.closest(args.outsideClickElement).length) {
                     closeSidesheet();
                 }
             });
 
         }
 
         function closeSidesheet() {
             $('#sidesheet').removeClass('is-active');
             $('body').removeClass('sidesheet-open');
         }
         function openSidesheet(e) {
             $('#sidesheet').addClass('is-active');
             $('body').addClass('sidesheet-open');   
         }
 
         return {
             init: init,
             openSidesheet: openSidesheet,
             closeSidesheet: closeSidesheet
         }
     })();
     // referrals sidesheet
        // 
        referralsSidesheet.init({outsideClickElement: '.data--referrals'});

        // open sidesheet       
        $('.data--referrals .data__row').on('click', function (e) {
            referralsSidesheet.openSidesheet(e);
        });
   }
  
   push(): void {
      this.emailControl.push({ "placeholder": "Your friends email address" });
   }
   pop(): void {
      this.emailControl.pop();
   }
   doAction(action: string): void {
      switch (action) {
         case 'email':
            $('.modal').modal('hide');
            $('#share-email-modal').modal('show');
            break;
            case 'whatsapp':
               //this.sendWithWhatsapp();
               break;
      }
   }
   viewEmail(): void {
      console.log(this.emailAddresses.toString())
   }
   sendEmail(): void {
      $('.emails').each((i, e) => {
         this.emailAddresses.push(e.value);
      })
      const parameters = new Map<string, string>();
      parameters.set('person_id', this.user?.person_id?.toString());
      parameters.set('referral_string', this.emailAddresses.toString());
      this.globalQuestionService.runCommandNew(`sendReferral`, parameters)
         .subscribe(response => {
            Alert('We sent your invite! Tell your friend to keep an eye on their inbox.');
         });

   }
  setSelectedCampaign(campaign: any): void {
   this.selectedtCampaign = campaign;

  }

  setDetails(event: any) :void {
   this.showDetails = event;
   this.globalQuestionService.spinner(true);
   setTimeout(() => {
      this.initBannerSlider();
      this.globalQuestionService.spinner(false);
   }, 1000);
   
  }
  setReferral(referral: any): void {
   this.selectedReferral = referral;
   this.selectedReferral.progress_json = JSON.parse(this.selectedReferral?.progress_json);
   console.log(this.selectedReferral);
   $('#sidesheet').addClass('is-active');
   $('body').addClass('sidesheet-open');   
  }
  setCampaignID(campaign_id: number): void {
   console.log(campaign_id)
  }


}
